<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="part">
<h1 class="parttitle" epub:type="title"><span epub:type="pagebreak" id="page_1" title="1"><span class="bor">PART ONE</span></span></h1>
<p class="partno">The Institutional Infrastructure of Black Nursing</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 11_Part01.vue?4b67b811